import { render } from "./UpsellDiff.vue?vue&type=template&id=37f551d4"
import script from "./UpsellDiff.vue?vue&type=script&lang=js"
export * from "./UpsellDiff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__